module.exports = __webpack_public_path__ + "img/rina-iso.8fa520bd.png";